import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { SEARCH_PARAMS } from 'constants/dataSets';
import {
  ORDER_KEY, ORDER_TYPE, SEARCH, SORT,
  STATUS,
} from 'constants/formFields';
import { ORDERS } from 'constants/interfaces';
import { dataMAListSchema } from 'utils/validators';

import type { TDataMAListSchema } from 'utils/validators';

const useMaterialityAssessmentListForm = () => {
  const [searchParams] = useSearchParams();
  const searchParam = searchParams.get(SEARCH_PARAMS.search) || '';

  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    watch,
  } = useForm<TDataMAListSchema>({
    mode: 'onChange',
    resolver: yupResolver(dataMAListSchema),
    defaultValues: {
      [SEARCH]: searchParam,
      [SORT]: {
        [ORDER_KEY]: '',
        [ORDER_TYPE]: ORDERS.asc,
      },
      [STATUS]: [],
    },
  });

  return {
    control,
    handleSubmit,
    getValues,
    setValue,
    watch,
  };
};

export default useMaterialityAssessmentListForm;
